import { IS_FLIPGIVE } from 'common/env';

export interface AuthLocation {
    hostname: string;
    port: string;
}

const localFlipGivePorts = ['5004', '5005'];
const localRaiseRightPorts = ['5002', '5003'];

export const getCurrentAuthLocation = (): AuthLocation =>
    typeof window !== 'undefined' ? window.location : { hostname: '', port: '' };

export const getAuthDomain = (
    location: AuthLocation = getCurrentAuthLocation(),
    isFlipGive: boolean = IS_FLIPGIVE
) => {
    if (location.hostname === 'localhost' || location.hostname === '127.0.0.1') {
        if (localFlipGivePorts.includes(location.port)) {
            return 'flipgive';
        }

        if (localRaiseRightPorts.includes(location.port)) {
            return 'raiseright';
        }

        return isFlipGive ? 'flipgive' : 'raiseright';
    }

    const [, domain] = location.hostname.split('.');
    return domain;
};
